module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-2.ab822c73.webp";